export default "__VITE_ASSET__ntzxxwf0__"